<template>
  <BListGroup style="max-height: 75vh; overflow: auto; border-top: 1px solid gray; border-bottom: 1px solid gray;">
    <BListGroupItem v-for="history in histories" :active="history.sessionId == selected" @click="selectChat(history.sessionId)" :key="history.sessionId">
      <div>
        <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 90%;">{{ history.text }}</div>
        <div style="font-size: 8pt; text-align: end;">{{ toLocaleDateTimeString(history.createdAt) }}</div>
        <button class="lai-delete-btn" @click.stop="deleteChat(history.sessionId)"><i class="fa fa-times"></i></button>
      </div>
    </BListGroupItem>
  </BListGroup>
</template>
<script>
export default {
  name: 'ChatHistoryList',
  props: {
    // single message: id, role, text, createdAt
    histories: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
  },
  emits: ['chat-selected'],
  data() {
    return {
      selectedChatSession: '',
    };
  },
  methods: {
    async deleteChat(sessionId) {
      this.$emit('delete-chat', sessionId);
    },
    selectChat(sessionId) {
      this.selectedChatSession = sessionId;
      this.$emit('chat-selected', sessionId);
    },
    toLocaleDateTimeString(dateTime) {
      const date = new Date(dateTime);
      return date.toLocaleString();
    },
  },
};
</script>
